module.exports = __webpack_public_path__ + "assets/img/pic.dadc5426.png";